export default __webpack_public_path__ + "static/media/circlepurple.b0c22630.svg";